/**
 * sectorLabels — etiqueta legible y familia de app por sector.
 * FOOD_SECTORS y sectorFamily espejan aws_lambdas/_shared_trial_usage/computeUsage.js
 * (si se añade un sector food nuevo, tocar AMBOS).
 */
export const SECTOR_LABEL_MAP = {
  peluquerias: "Peluquerías",
  peluqueria: "Peluquería",
  barberia: "Barbería",
  estetica: "Estética",
  salud: "Salud",
  spa: "SPA",
  consultoria: "Consultoría",
  despacho_abogados: "Despacho de Abogados",
  lavadero: "Lavadero",
  marketing: "Marketing genérico",
  autoescuela: "Autoescuela",
  fisioterapia: "Fisioterapia",
  osteopatia: "Osteopatía",
  psicologia: "Psicología",
  canina: "Peluquería canina",
  tatuajes: "Tatuajes",
  dentista: "Dentista",
  pizzeria: "Pizzería",
  comida_para_llevar: "Comida para llevar",
  restaurante: "Restaurante",
  restaurantes: "Restaurante",
  bar: "Bar",
  bares_deportes: "Bar Deportes",
  bares_tematicos: "Bar Temático",
  distribucion: "Distribución",
  general: "General",
  otro: "Otro",
};

const FOOD_SECTORS = new Set([
  "comida_para_llevar", "pizzeria", "restaurante", "restaurantes",
  "bar", "bares_deportes", "bares_tematicos", "distribucion",
]);

// Canonicaliza variantes del mismo sector (espejo de normalizeSector del backend):
// evita opciones duplicadas en filtros cuando conviven el sector del snapshot
// (canónico) y la categoría cruda del lead.
export function canonicalSector(sector) {
  const s = String(sector || "")
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // sin acentos: "Peluquería" → "peluqueria"
    .replace(/\s+/g, "_");
  if (s === "restaurantes") return "restaurante";
  if (s === "peluquerias") return "peluqueria";
  return s;
}

export function sectorLabel(sector) {
  if (!sector) return "—";
  if (SECTOR_LABEL_MAP[sector]) return SECTOR_LABEL_MAP[sector];
  return sector.charAt(0).toUpperCase() + sector.slice(1).replace(/_/g, " ");
}

export function sectorFamily(sector) {
  const s = String(sector || "").toLowerCase();
  if (FOOD_SECTORS.has(s)) return "food";
  if (s === "marketing") return "marketing";
  if (s === "autoescuela") return "driving_school";
  return "appointments";
}
